export function getVisibility(visibilityJson, module) {
    let visblty = 1;
    if(visibilityJson && visibilityJson.length>2){
        let visibilityArr = JSON.parse(visibilityJson);
        for(let i=0; i<visibilityArr.length; i++){
          if(visibilityArr[i].moduleName===module){
            visblty = visibilityArr[i].visibility;
          }
        }
    }
    return visblty;
}